import { createRoutes } from './actionCreators'; 
import { createAllowedRoutes } from '../utils/routes';


export function createRoutesForUser(userRole) {
  return dispatch => {
    let routes = createAllowedRoutes(userRole);
    dispatch(createRoutes(routes))
  }
}




// WEBPACK FOOTER //
// ./src/actions/generalActions.js